import axios from 'axios';
import { AccordionResponse } from 'types/overrides/chart';
import { environment } from 'environments/environment';

export const getValuesAsync = async (requestBody: AccordionResponse) => {
    try {
        let response: any;
        const getValues = async () => {
            await axios
                .post(`${environment.apiBaseUrl}devices/values`, requestBody, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${environment.authToken}`
                    }
                })
                .then((res) => {
                    console.log(res);
                    response = res.data.data;
                })
                .catch((err) => console.log(err));
        };
        await getValues();
        return response;
    } catch (error) {
        // Handle error, e.g., show error message or throw an exception
        console.error('Error fetching values:', error);
        throw error;
    }
};

export default getValuesAsync;
